// @flow

/**
 * Data Display Placeholder
 * Shown when a display definition hasn't arrived yet or is unavailable
 */

import React from 'react';
import styled from 'styled-components';

const PlaceholderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  margin: 0.5rem 0;
  padding: 1rem;
  border: 1px dashed rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  background: var(--card-background, #f9fafb);
  color: rgba(0, 0, 0, 0.4);
  font-size: 0.85rem;
  font-style: italic;
`;

type Props = {
  message?: string,
};

const DataDisplayPlaceholder = ({ message }: Props) => (
  <PlaceholderContainer>
    {message || 'Loading visualisation...'}
  </PlaceholderContainer>
);

export default DataDisplayPlaceholder;
